const USER_LS_ = "V1_asa_user";

export const onLogin = (email: string, password: string) => {
  if (email === "ff@icarustools.com" && password === "w8qcfspElVy3t7l") {
    try {
      localStorage.setItem(USER_LS_, email);
      return true;
    } catch (error) {}
  }

  return false;
};

export const getMe = () => {
  return localStorage.getItem(USER_LS_) ? true : false;
};

export const onLogout = () => {
  try {
    localStorage.removeItem(USER_LS_);
    return true;
  } catch (error) {}
};
